import React from 'react';

import { Grid } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import { loadTagsByCategory } from 'scenes/GalleryTags/sources/galleryTags';
import { loadGalleryTagsCategories } from 'scenes/GalleryTags/sources/galleryTags';

import CategorySelect from './CategorySelect';
import { CATEGORY, TAGS } from './constants';
import { tagsSchema } from './schemas';

const handleLoadTagsByCategory = async (params) => {
  if (params[CATEGORY]) {
    return await loadTagsByCategory({ name: params[CATEGORY].name });
  }
};
const AddsTag = withForm({
  validationSchema: tagsSchema,
})(({ loading, onExited, onClose, open, onAddCategory, values }) => {
  return (
    <SidePageV2
      open={open}
      onExited={onExited}
      onClose={onClose}
      size={'md'}
      loading={loading}
    >
      <SidePageV2.Title title={'Add Tags'} />
      <SidePageV2.Content>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <CategorySelect
              label={'Category'}
              name={CATEGORY}
              source={loadGalleryTagsCategories}
              padding={0}
              withDeselectButton={true}
              onAdd={onAddCategory}
              addOptionLabel={'Category'}
            />
          </Grid>
          <Grid item xs={12}>
            <FormField.ChipsInput
              name={TAGS}
              label={'Tags'}
              required={true}
              freeSolo={true}
              padding={'0'}
              source={handleLoadTagsByCategory}
              depends={[CATEGORY]}
              normalizeValue={(_, options) => options}
              disabled={!values[CATEGORY]}
              isTagRemovable={(opt) => !opt.id}
            />
          </Grid>
        </Grid>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default AddsTag;
